import { z } from 'zod'

import type { Equal, ExpectTrue } from '../types/validation'

import { type CmsButtonProps, CmsButtonPropsSchema } from './cms-button'
import {
  type ProductCategories,
  ProductCategoriesSchema,
} from './product-category'

export type ProductGradesProps = {
  technicalName?: string
  categories: ProductCategories
  title?: string
  subtitle?: string
  button?: CmsButtonProps
}

export const ProductGradesPropsSchema = z.object({
  technicalName: z.string().optional(),
  title: z.string().optional(),
  subtitle: z.string().optional(),
  categories: ProductCategoriesSchema,
  button: CmsButtonPropsSchema.optional(),
})

/* Schemas validation */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type TestProductGrades = ExpectTrue<
  Equal<ProductGradesProps, z.infer<typeof ProductGradesPropsSchema>>
>
